import { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { purple } from '@mui/material/colors';
import {
  useMediaQuery,
  Typography,
  Box,
  FormControl,
  TextField,
  Button,
  Checkbox,
  Select,
  MenuItem,
  FormControlLabel,
  Chip,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { standardString } from '../../../utils/utils';
import { actions } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { isEmpty } from 'lodash';
import { deleteTrainingNames, getTrainingNames } from '../helpers';
import collections from '../../../constants/FirestoreCollections';
const dialogflowUrl = process.env.REACT_APP_DIALOGFLOW;
const MySwal = withReactContent(Swal);

const useStyles = (small) => {
  return makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    training: {
      paddingBlock: 32,
    },
    title: {
      fontSize: 24,
    },
    caseItem: {
      padding: 16,
    },
    specialtyItem: {
      padding: 16,
      display: 'flex',
      alignItems: 'center',
    },
    sectionRef: {
      fontWeight: 'bold',
    },
    synonymTag: {
      marginRight: 8,
      backgroundColor: purple[500],
      '&:hover': {
        backgroundColor: purple[300],
      },
      cursor: 'pointer',
      color: 'white',
      borderRadius: 4,
      padding: 4,
    },
    chipActive: {
      background: theme.palette.primary.main,
      color: 'white',
    },
    chip: {
      cursor: 'pointer',
      '&:hover': {
        opacity: '.7',
      },
    },
    finishButton: {
      background: theme.palette.secondary.main,
      color: 'white',
      '&:hover': {
        background: theme.palette.secondary.light,
      },
    },
    deleteIcon: {
      cursor: 'pointer',
      color: '#ccc',
      '&:hover': {
        color: 'red',
      },
    },
    copySession: {
      marginLeft: 'auto',
      fontSize: 12,
      background: '#eee',
      borderRadius: '3rem',
      margin: '0 8px',
      padding: '0 8px',
      '&:hover': {
        background: '#ccc',
        cursor: 'pointer',
      },
    },
  }));
};

export default function EntitiesHandler() {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const organization = useSelector((state) => state.app.organization);
  const organizations = useSelector((state) => state.app.organizations);
  const firebase = useFirebase();
  const firestore = useFirestore();
  const appDispatch = useDispatch();

  // df changes handler
  const [actualSynonym, setActualSynonym] = useState('');
  const [checks, setChecks] = useState([]);
  const [entityName, setEntityName] = useState('LastName');
  const [operation, setOperation] = useState('add');
  const [clientsToChange, setClientsToChange] = useState({});
  const [isGlobalChange, setIsGlobalChange] = useState(true);
  const [synonyms, setSynonyms] = useState([]);
  const [value, setValue] = useState('');
  const [configuration, setConfiguration] = useState();
  const [token, setToken] = useState('');
  const [refreshData, setRefreshData] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (organization.id) {
        try {
          const newToken = await firebase.auth().currentUser.getIdToken(true);
          setToken(newToken);
          const configuration = await getTrainingNames(newToken, organization.id);
          setConfiguration(configuration);
        } catch (error) {
          console.error('Error al obtener los datos:', error);
        }
      }
    };

    fetchData();
  }, [organization.id, refreshData]);

  const handleChangeEntity = () => {
    if (!operation || !entityName) {
      return appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Debe seleccionar la operacion y la entidad`,
          snackbarSeverity: 'error',
        },
      });
    }
    if (!value) {
      return appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Debe ingresar el valor de la entidad`,
          snackbarSeverity: 'error',
        },
      });
    }
    if (synonyms.length === 0) {
      return appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Debe ingresar al menos un sinonimo`,
          snackbarSeverity: 'error',
        },
      });
    }

    let clients = [];
    if (isGlobalChange) {
      clients = organizations.map((e) => e.id);
    } else clients = Object.keys(clientsToChange).filter((key) => !!clientsToChange[key]);

    const payload = {
      organizationId: organization.id,
      entityName: entityName,
      entityValue: {
        value: standardString(value),
        synonyms: synonyms,
      },
      clients,
      type: 2,
    };

    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(async (idToken) => {
        axios(`${dialogflowUrl}/entity`, {
          method: operation === 'add' ? 'post' : 'delete',
          headers: {
            Authorization: `bearer ${idToken}`,
          },
          data: payload,
        });
      })
      .then(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: `Las entidades se actualizaran, en los proximos minutos vera los cambios`,
            snackbarSeverity: 'success',
          },
        });
        setValue('');
        setSynonyms([]);
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const toggleAllChecks = () => {
    const allChecked =
      configuration?.trainingNames?.length > 0 &&
      configuration.trainingNames.every((e) =>
        checks.find(
          (obj) =>
            obj.nombreCompleto === e.nombreCompleto &&
            obj.apellidoCompleto === e.apellidoCompleto &&
            obj.session === e.session,
        ),
      );

    if (allChecked) {
      setChecks([]);
    } else {
      setChecks(configuration?.trainingNames);
    }
  };

  const handleDeleteName = async () => {
    if (checks.length === 0) {
      return appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: 'Debe seleccionar al menos uno',
          snackbarSeverity: 'info',
        },
      });
    }

    const confirmation = await MySwal.fire({
      text: '¿Está seguro que quiere borrarlos?',
      showConfirmButton: true,
      showDenyButton: true,
      icon: 'error',
    });

    if (!confirmation.isConfirmed) return;

    try {
      let updatedTrainingNames;
      const softwaresWithTrainingNamesSub = ['macena', 'gehos', 'macenaV2'];
      const isSubcollectionTrainingNames = softwaresWithTrainingNamesSub.includes(
        organization.healthSoftware.name,
      );
      if (isSubcollectionTrainingNames) {
        updatedTrainingNames = filterTrainingNames(configuration.trainingNames, checks);

        const params = {
          token,
          documentId: configuration.id,
          dataToDelete: {
            trainingNames: updatedTrainingNames,
          },
        };

        await deleteTrainingNames(params);
      } else if (organization.healthSoftware.name === 'mrTurno5') {
        updatedTrainingNames = filterTrainingNames(configuration.trainingNames, checks, true);

        await firestore.collection(collections.configurations).doc(configuration.id).update({
          name: 'trainingNames',
          organizationId: organization.id,
          trainingNames: updatedTrainingNames,
        });
      }

      MySwal.fire('Borrado', 'Se han borrado los casos seleccionados', 'success');
      setRefreshData(!refreshData);
    } catch (error) {
      console.error('handleDeleteName', error);
      MySwal.fire('Error', 'Disculpe, ocurrió un error.', 'error');
    }
  };

  const filterTrainingNames = (trainingNames, checks, exclude = false) => {
    return trainingNames?.filter((training) => {
      const match = checks.find(
        (e) =>
          e.nombreCompleto === training.nombreCompleto &&
          e.apellidoCompleto === training.apellidoCompleto &&
          e.session === training.session,
      );
      return exclude ? !match : match;
    });
  };

  return (
    <Box mt={4} mb={2}>
      <Typography className={classes.sectionRef}>MODIFICAR ENTIDADES</Typography>
      <Box display="flex">
        <Box my={2}>
          <Select
            value={operation}
            sx={{ minWidth: '200px' }}
            onChange={(e) => setOperation(e.target.value)}
          >
            <MenuItem value="add">Agregar</MenuItem>
            <MenuItem value="delete">Borrar</MenuItem>
          </Select>
        </Box>
        <Box ml={2} my={2}>
          <Select
            value={entityName}
            sx={{ minWidth: '200px' }}
            onChange={(e) => setEntityName(e.target.value)}
          >
            <MenuItem value="FirstName">Nombres</MenuItem>
            <MenuItem value="LastName">Apellidos</MenuItem>
          </Select>
        </Box>
        <Box ml={2} my={2} display="flex">
          <FormControlLabel
            control={
              <Checkbox
                checked={isGlobalChange}
                onChange={(e) => setIsGlobalChange(e.target.checked)}
              />
            }
            name="scope"
            label="Modificar todos los clientes"
          />
        </Box>
      </Box>
      <Box mb={2}>
        {!isGlobalChange && (
          <Box mt={2} display="flex" flexWrap="wrap">
            {organizations
              .filter((e) => e.disabled === false)
              .filter((e) => e.provider && !isEmpty(e.provider.dfId?.trim()))
              .map((e, index) => (
                <Box
                  key={index}
                  mr={2}
                  mb={1}
                  onClick={() => {
                    setClientsToChange({ ...clientsToChange, [e.id]: !clientsToChange[e.id] });
                  }}
                >
                  <Chip
                    label={e.name}
                    className={
                      clientsToChange[e.id] ? `${classes.chip} ${classes.chipActive}` : classes.chip
                    }
                  />
                </Box>
              ))}
          </Box>
        )}
      </Box>
      <Box display="flex" alignItems="center">
        <FormControl className={classes.formControl}>
          <TextField
            label="Nombre de la entidad"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              e.target.value ? setSynonyms([e.target.value]) : setSynonyms([]);
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl} sx={{ ml: 2 }}>
          <TextField
            label="Sinonimo"
            value={actualSynonym}
            onChange={(e) => setActualSynonym(e.target.value)}
          />
        </FormControl>
        <Button
          variant="outlined"
          sx={{ ml: 2, minWidth: 'auto', maxWidth: '40px', fontWeight: 'bold' }}
          onClick={() => {
            if (!actualSynonym) {
              return appDispatch({
                type: actions.alert,
                alert: {
                  snackbarOpen: true,
                  snackbarMessage: `Debe ingresar un valor`,
                  snackbarSeverity: 'error',
                },
              });
            } else {
              setSynonyms([...synonyms, actualSynonym]);
              setActualSynonym('');
            }
          }}
        >
          +
        </Button>
        <Box display="flex" alignItems="center" px={2}>
          {synonyms.map((e, index) => (
            <Box
              key={index}
              onClick={() => {
                setSynonyms(synonyms.filter((synonym) => synonym !== e));
              }}
              className={classes.synonymTag}
            >
              <Typography>{e}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Box mt={4}>
        <Button variant="contained" className={classes.finishButton} onClick={handleChangeEntity}>
          Entrenar
        </Button>
      </Box>
      {configuration?.trainingNames?.length > 0 && (
        <Box mt={2} mb={1} display="flex" justifyContent="space-between">
          <Typography sx={{ fontSize: 18 }}>Casos para entrenar</Typography>
          <Box display="flex" gap={1}>
            <Button
              onClick={toggleAllChecks}
              size="small"
              variant="outlined"
              color="secondary"
              sx={{
                textTransform: 'none',
                fontSize: 13,
                padding: '4px 10px',
                borderRadius: 2,
              }}
            >
              {configuration.trainingNames.every((e) =>
                checks.find(
                  (obj) =>
                    obj.nombreCompleto === e.nombreCompleto &&
                    obj.apellidoCompleto === e.apellidoCompleto &&
                    obj.session === e.session,
                ),
              )
                ? 'Desmarcar todos'
                : 'Marcar todos'}
            </Button>
            <Delete
              sx={{ width: '42px', display: 'flex', justifyContent: 'center', marginRight: 0 }}
              className={classes.deleteIcon}
              onClick={() => handleDeleteName()}
            />
          </Box>
        </Box>
      )}
      {configuration?.trainingNames?.map((e, index) => (
        <Box key={index} display="flex" alignItems="center">
          <Typography sx={{ fontWeight: 'lighter' }}>
            {e.nombreCompleto}, {e.apellidoCompleto}
          </Typography>
          {e && e.session && (
            <Typography
              className={classes.copySession}
              onClick={() => {
                navigator.clipboard.writeText(e.session);
                appDispatch({
                  type: actions.alert,
                  alert: {
                    snackbarOpen: true,
                    snackbarMessage: `Copiado en portapapeles`,
                    snackbarSeverity: 'info',
                  },
                });
              }}
            >
              Copiar session
            </Typography>
          )}
          <Checkbox
            checked={
              !!checks.find(
                (obj) =>
                  obj.nombreCompleto === e.nombreCompleto &&
                  obj.apellidoCompleto === e.apellidoCompleto &&
                  obj.session === e.session,
              )
            }
            onChange={(_, checked) => {
              if (!checked)
                setChecks(
                  checks.filter(
                    (obj) =>
                      obj.nombreCompleto !== e.nombreCompleto ||
                      obj.apellidoCompleto !== e.apellidoCompleto ||
                      obj.session !== e.session,
                  ),
                );
              else setChecks([...checks, e]);
            }}
          />
        </Box>
      ))}
    </Box>
  );
}
